import { actions } from "../../utils/constants";
import { accessToken, refreshToken } from "../../utils/helper";


const initialState = {
    loading: false,
}
const loadingReducer = (state = initialState, action) => {

    switch (action.type) {
        case actions.SET_LOADING: return { ...state, loading: action.value };
        default: return { ...state }
    }
}

export default loadingReducer